/**
 * Admin /enroll-qr-jit — Phase G+ (2026-05-25) JIT signup
 * Card 2. Unauthenticated route; auth artifact is the
 * OTP-proven loginflow enrollmentHandle in search params.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { EnrollQRJITPage } from "@/features/enroll-qr/pages/enroll-qr-jit-page";

const searchSchema = z.object({
  handle: z.string().min(8).max(256),
  email: z.string().email().max(256),
  // Arch-P1 — reject protocol-relative + backslash-escaped
  // URLs that would let a crafted link bounce the user to a
  // cross-origin destination post-enrollment.
  continue: z
    .string()
    .regex(/^\/[^/\\]/, "must be a same-origin path")
    .max(2048)
    .optional(),
});

export const Route = createFileRoute("/enroll-qr-jit")({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    if (!search.handle || !search.email) {
      throw redirect({ to: "/login" });
    }
  },
  component: EnrollQRJITPage,
});
